const AccountStatus = {
    ACTIVE : 'ACTIVE',
    SUSPENDED : 'SUSPENDED',
    ARCHIVED : 'ARCHIVED'
};

export default AccountStatus;